import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import size from 'lodash/size';
import {
  API,
  withRouter,
  viShortcut,
} from 'vibeguide';
import Grid from '@mui/material/Grid';
import OrderStatusCard from '../OrderStatusCard';

function PausedOrderTables() {
  const [summaries, setSummaries] = useState({});

  /**
   * Get the Order Status Summary
   */
  const getSummaries = async () => {
    const current = await API.Order.Reporting.Summaries.Paused.current();
    const ending = await API.Order.Reporting.Summaries.Paused.ending();

    setSummaries({
      current,
      ending,
    });
  };

  useEffect(() => {
    getSummaries();
  }, []);

  return (
    <Grid className="PausedOrderTables" spacing={2} container>
      <Grid size={6}>
        <OrderStatusCard
          title="Running in the next 7 Days"
          linkUrl="../../paused/current"
          icon={viShortcut}
          iconStyles={{
            transform: 'scaleY(-1) rotate(90deg)',
          }}
          tableData={{
            hideColumn: false,
            columns: ['name', 'status', 'deliveredImpressions', 'endDate'],
            data: get(summaries, 'current', []),
          }}
          loading={size(summaries) <= 0}
        />
      </Grid>

      <Grid size={6}>
        <OrderStatusCard
          title="Ends in 30 Days or Less"
          linkUrl="../../paused/ending"
          icon={viShortcut}
          iconStyles={{
            transform: 'scaleY(-1)',
          }}
          tableData={{
            hideColumn: false,
            columns: ['name', 'status', 'deliveredImpressions', 'endDate'],
            data: get(summaries, 'ending', []),
          }}
          loading={size(summaries) <= 0}
        />
      </Grid>
    </Grid>
  );
}

export default withRouter(PausedOrderTables);
